import { FileEarmarkText } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

const DuplicateVOM = ({
  title = "VOM Already Exists!",
  body = (
    <p className="text-muted">
      A Verification of Mortgage (VOM) request has already been generated for
      this specific Property or Loan within our records.
    </p>
  ),
  feeNote = true,
}) => {
  const navigate = useNavigate();

  return (
    <div className="bg-light min-vh-100 py-5 duplicate-page">
      <div className="container">
        {/* Breadcrumb */}

        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-7">
            <div className="card border-0 shadow-sm p-5 p-md-5">
              {/* Alert Icon */}
              <div className="text-center mb-4">
                <div className="info-icon-wrapper shadow-sm mx-auto">
                  <FileEarmarkText />
                </div>
              </div>

              {/* Header */}
              <div className="text-center mb-4">
                <h2 className="fw-bold mb-2">{title}</h2>
                {body}
              </div>

              {/* Existing Record Details */}
              {/* <div className="info-details-box bg-white p-4 mb-4">
                <div className="row mb-2">
                  <div className="col-sm-5 text-muted">Current Status:</div>
                  <div className="col-sm-7">
                    <span className="text-warning fw-bold">
                      {existingVom.status}
                    </span>
                  </div>
                </div>
              </div> */}

              {/* System Note */}
              {feeNote && (
                <div className="alert alert-light border-0 text-center small text-muted mb-4 px-4">
                  Our system detected a matching record, preventing a duplicate
                  submission.
                  <strong> No new fees have been charged.</strong>
                </div>
              )}

              {/* Action Buttons */}
              <div className="d-grid gap-3 d-md-flex justify-content-md-center">
                <button
                  className="btn btn-outline-grey px-5 py-4 text-black"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
              </div>

              {/* Support Footer */}
              <div className="mt-5 pt-3 border-top text-center">
                <p className="text-muted small mb-0">
                  <a
                    href="https://helpdesk.loanlinq.com/login"
                    className="text-primary text-decoration-none"
                  >
                    Contact support?
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style>{`
       .duplicate-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #fff7f4, #fefefe);
          text-align: center;
          padding: 20px;
          animation: fadeIn 0.6s ease-out;
        }

        .info-icon-wrapper {
          background-color: #fff9e6;
          width: 84px;
          height: 84px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #ffc107;
        }
        .info-details-box {
          border: 1px solid #eee;
          border-radius: 12px;
          background-color: #fafafa;
        }
        .text-warning {
          color: #856404 !important; /* Darker amber for readability */
        }
        .btn-primary {
          background-color: #2b7de9;
          border-color: #2b7de9;
        }
        .breadcrumb-item + .breadcrumb-item::before {
          content: ">";
        }
      `}</style>
    </div>
  );
};

export default DuplicateVOM;
